import { createFileRoute } from "@tanstack/react-router";

import { HomePage } from "../../../workspaces/work-atlas/pages/HomePage";

export const Route = createFileRoute("/_console/p/$org/$project/work-atlas/home")({
  component: HomePage,
});
